let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("jXE7i"), load("fJU8y")]).then(() => parcelRequire('5I6Jc'));